import React, { useMemo } from "react";
import { SALE_ORDER_STATUS } from "../../../../data/enums";
import { ProductOrderFilterType, valueToText } from "../../../../configs/filterTypes";

export interface StatusProgressProps {
    status?: SALE_ORDER_STATUS | string | null;
    className?: string;
    isReserve?: boolean;
}

const StatusProgress: React.FC<StatusProgressProps> = ({
    status,
    className,
    isReserve = false,
}) => {
    const saleOrderStatuses: SALE_ORDER_STATUS[] = useMemo(
        () => [
            SALE_ORDER_STATUS.OPEN,
            SALE_ORDER_STATUS.LOGISTIC_REVIEWED,
            SALE_ORDER_STATUS.MATERIAL_REQUESTED_AND_MANUFACTURING,
            SALE_ORDER_STATUS.IMPORTING_AND_EXPORTING,
            SALE_ORDER_STATUS.COMPLETED,
        ],
        [],
    );

    const normalizedStatus = (status || "").toString().toUpperCase() as SALE_ORDER_STATUS;
    const isCancelled = normalizedStatus === SALE_ORDER_STATUS.CANCELLED;
    const isCompleted = normalizedStatus === SALE_ORDER_STATUS.COMPLETED;

    const currentIndex = useMemo(
        () => saleOrderStatuses.indexOf(normalizedStatus),
        [normalizedStatus, saleOrderStatuses],
    );

    const labels = useMemo(
        () =>
            saleOrderStatuses.map((s) =>
                isReserve && s === SALE_ORDER_STATUS.IMPORTING_AND_EXPORTING
                    ? "Nhập kho"
                    : valueToText(ProductOrderFilterType, "status", s) || s,
            ),
        [saleOrderStatuses, isReserve],
    );

    const getLabelClass = (i: number) => {
        if (isCancelled) return "tw-text-red-600 tw-font-semibold";
        if (currentIndex < 0) return "";
        if (i < currentIndex) return "tw-text-black tw-font-semibold";
        if (i === currentIndex) return "tw-text-black tw-font-semibold";
        return "tw-text-gray-600";
    };

    const getSegmentClass = (i: number) => {
        if (isCompleted) return "tw-bg-emerald-600";
        if (isCancelled) return "tw-bg-red-600";
        if (currentIndex < 0) return "tw-bg-secondary";
        if (i < currentIndex) return "tw-bg-emerald-600";
        if (i === currentIndex) return "tw-bg-orange-500";
        return "tw-bg-secondary";
    };

    return (
        <div className={className} style={{ width: "100%" }}>
            {/* Segmented progress track with labels under each step */}
            <div className="tw-w-full tw-flex tw-gap-1">
                {saleOrderStatuses.map((_, i) => (
                    <div key={i} className="tw-flex-1 tw-flex tw-flex-col tw-items-stretch">
                        <div
                            className={`tw-h-2 tw-rounded ${getSegmentClass(i)}`}
                            aria-hidden
                        />
                        <div className="tw-text-[12px] tw-mt-2 tw-text-center">
                            <span className={getLabelClass(i)}>
                                {labels[i]}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StatusProgress;
